import { Utils } from "utils";
import { IPlace, Iterable } from "types";

export class Places {
  constructor(private places: Iterable<IPlace>[]) {
    this.places = places;
  }

  getList() {
    return this.places;
  }

  sortByRating() {
    const maxRating = Utils.Places.calculateMaxRatingFor(this.places);
    const maxUserRating = Utils.Places.calculateMaxUserRatingFor(this.places);

    const sortedPlaces = this.places.sort((a, b) => {
      const aRating = Utils.Places.calculateCustomRating(
        a,
        maxRating,
        maxUserRating
      );
      const bRating = Utils.Places.calculateCustomRating(
        b,
        maxRating,
        maxUserRating
      );
      return bRating - aRating;
    });

    this.places = sortedPlaces;
  }
}
